<template>
    <v-container fluid>
        <v-row>
            <ImageViewer
                :images="imageList"
                :toggler="lightboxShow"
                :index="lighboxIndex"
                @closeViewer="lightboxShow = false"
            >
            </ImageViewer>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-title> {{ $t('labels.phase') }} {{ phase }} </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-data-table
                                    :headers="objectHeaders"
                                    :items="objectList"
                                    fixed-header
                                    dense
                                    class="row-item"
                                    :items-per-page="-1"
                                    :hide-default-footer="true"
                                    :height="200"
                                    :no-data-text="$t('labels.noData')"
                                >
                                    <template v-slot:item="row">
                                        <tr :class="{'cursor-pointer': true}">
                                            <td v-if="row.item.file != ''">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <v-btn
                                                            icon
                                                            v-bind="attrs"
                                                            @click="download(row.item.file)"
                                                            v-on="on"
                                                        >
                                                            <v-icon small>fa-download</v-icon>
                                                        </v-btn>
                                                        <v-btn depressed @click="fileClicked(row.item)" icon>
                                                            <v-icon small>fas fa-eye</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ $t('tooltips.download') }}</span>
                                                </v-tooltip>
                                            </td>
                                            <td v-else>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <v-btn icon v-bind="attrs" v-on="on">
                                                            <v-icon small color="red">fas fa-exclamation</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ $t('tooltips.seafarerHasNoDocument') }}</span>
                                                </v-tooltip>
                                            </td>
                                            <td>
                                                {{ row.item.document_type_display }}
                                            </td>
                                            <td>
                                                {{ row.item.document_category_display }}
                                            </td>
                                            <td>
                                                {{ row.item.expiry_date }}
                                            </td>
                                            <td>
                                                {{ row.item.document_number }}
                                            </td>
                                            <td>
                                                {{ row.item.information }}
                                            </td>
                                            <td>
                                                {{ row.item.remarks }}
                                            </td>
                                            <td>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <v-btn
                                                            v-if="row.item.confirmed == true"
                                                            icon
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            class="pt-0 mt-0"
                                                            color="green"
                                                            @click="approve(row.item)"
                                                        >
                                                            <v-icon small>fas fa-check</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            v-else
                                                            icon
                                                            v-bind="attrs"
                                                            @click="approve(row.item)"
                                                            v-on="on"
                                                            class="pt-0 mt-0"
                                                            color="red"
                                                        >
                                                            <v-icon small>fas fa-minus</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span v-if="row.item.confirmed == false">{{
                                                        $t('tooltips.approve')
                                                    }}</span>
                                                    <span v-else>{{ $t('tooltips.approved') }}</span>
                                                </v-tooltip>
                                            </td>
                                            <td v-if="row.item.confirmed == true">
                                                {{ row.item.confirmed_data }}
                                            </td>
                                            <td v-else></td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import DocumentChecklistItem from '../models/DocumentChecklistItem';
import ImageViewer from './trinkets/ImageViewer';

export default {
    name: 'DocumentChecklistPhase',
    components: {
        ImageViewer,
    },
    props: ['phase', 'application', 'inEditMode'],
    data: function () {
        return {
            item: new DocumentChecklistItem({}),
            itemValidation: new DocumentChecklistItem({}, true),
            objectList: [],
            objectHeaders: [
                {text: this.$t('fields.file'), sortable: false, width: '10%'},
                {text: this.$t('fields.documentType'), sortable: false, width: '10%'},
                {text: this.$t('fields.documentCategory'), sortable: false, width: '10%'},
                {text: this.$t('fields.expiryDate'), sortable: false, width: '10%'},
                {text: this.$t('fields.documentNo'), sortable: false, width: '10%'},
                {text: this.$t('fields.information'), sortable: false, width: '20%'},
                {text: this.$t('fields.remarks'), sortable: false, width: '10'},
                {text: '', value: 'actions', type: '', sortable: false, allowFilter: false, width: '5%'},
                {text: '', value: 'actions', type: '', sortable: false, allowFilter: false, width: '15%'},
            ],
            imageList: [],
            imageFormats: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            lightboxShow: false,
            lighboxIndex: 0,
        };
    },

    methods: {
        fileClicked(item) {
            let link = item.uploaded_file.link;
            if (
                this.imageFormats.includes(
                    item.uploaded_file.original_name.slice(
                        ((item.uploaded_file.original_name.lastIndexOf('.') - 1) >>> 0) + 2,
                    ),
                )
            ) {
                const index = this.imageList.indexOf(link);
                if (index !== null && index != -1) {
                    this.lighboxIndex = index;
                }
                this.lightboxShow = true;
            } else {
                window.open(link);
            }
        },
        approve(item) {
            if (this.inEditMode) {
                let vm = this;
                item.confirmed = !item.confirmed;
                let user = this.$myStore.state.user.id;
                this.$APICall('put', 'application-documents/' + item.id, {user}, (data, success) => {
                    if (success) {
                        vm.reloadData();
                    }
                });
            }
        },
        reloadData() {
            let vm = this;
            let phase = this.phase;
            this.$APICall('get', 'application-documents/' + this.application.id, {phase}, (data, success) => {
                if (success) {
                    vm.objectList = data;
                    vm.objectList.forEach((element) => {
                        if (element.uploaded_file != null) {
                            if (
                                vm.imageFormats.includes(
                                    element.uploaded_file.original_name.slice(
                                        ((element.uploaded_file.original_name.lastIndexOf('.') - 1) >>> 0) + 2,
                                    ),
                                )
                            ) {
                                vm.imageList.push(element.uploaded_file.link);
                            }
                        }
                    });
                }
            });
        },
    },
    mounted() {
        this.reloadData();
    },
};
</script>
